import { extendTheme } from '@chakra-ui/react'
import tenant from '@/lib/tenant'
import { theme as baseTheme } from './base/theme'
import { paletteFromHex } from './buildBrandTheme'
import { withFlagFont } from './flagFont'

function tokenPalette(hex?: string, fallback?: Record<number, string>) {
	if (!hex) return fallback
	return paletteFromHex(hex) ?? fallback
}

const theme = () =>
	extendTheme({
		...baseTheme,
		fonts: {
			...baseTheme.fonts,
			heading: withFlagFont(tenant.theme.fonts.sans.family),
			body: withFlagFont(tenant.theme.fonts.sans.family),
			...(tenant.theme.fonts.mono
				? { mono: tenant.theme.fonts.mono.family }
				: {}),
		},
		radii: {
			...(baseTheme.radii ?? {}),
			...tenant.theme.radii,
		},
		colors: {
			...baseTheme.colors,
			primary: tokenPalette(
				tenant.theme.colors.primary,
				baseTheme.colors?.primary
			),
			secondary: tokenPalette(
				tenant.theme.colors.secondary,
				baseTheme.colors?.secondary
			),
			accent: tokenPalette(tenant.theme.colors.accent),
			success: tokenPalette(tenant.theme.colors.success),
			warning: tokenPalette(tenant.theme.colors.warning),
			destructive: tokenPalette(tenant.theme.colors.destructive),
		},
		styles: {
			...baseTheme.styles,
			global: {
				...(baseTheme.styles?.global ?? {}),
				body: {
					...(baseTheme.styles?.global?.body ?? {}),
					bg: tenant.theme.colors.background,
					color: tenant.theme.colors.foreground,
				},
			},
		},
	})

export default theme
